import { BuildingPermit, BuildingPermitObject } from './BuildingPermit';

export type BuildingPermitRevisionGroupObject = {
  original: BuildingPermitObject;
  revisions: Array<BuildingPermitObject>;
};

export class BuildingPermitRevisionGroup {
  original: BuildingPermit;
  revisions: Array<BuildingPermit>;

  static fromPermits(
    buildingPermits: Array<BuildingPermit>,
  ): BuildingPermitRevisionGroup {
    const sortedPermits = buildingPermits.sort((a, b) => {
      return a.revisionNum < b.revisionNum ? -1 : 1;
    });
    const original = sortedPermits[0];
    const revisions = sortedPermits.slice(1);
    return new BuildingPermitRevisionGroup(original, revisions);
  }

  static fromObject(
    object: BuildingPermitRevisionGroupObject,
  ): BuildingPermitRevisionGroup {
    return new BuildingPermitRevisionGroup(
      BuildingPermit.fromObject(object.original),
      object.revisions.map(revision => BuildingPermit.fromObject(revision)),
    );
  }

  constructor(original: BuildingPermit, revisions: Array<BuildingPermit>) {
    this.original = original;
    this.revisions = revisions;
  }

  toObject(): BuildingPermitRevisionGroupObject {
    return {
      original: this.original.toObject(),
      revisions: this.revisions.map(revision => revision.toObject()),
    };
  }
}
